if(!customElements.get('marquee-text')) {
  class MarqueeText extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('span');
      this.containerLeft = this.parentNode.getBoundingClientRect().left;
      this.currentLeft = 0;
      this.stopped = false;
      this.offsetMargin = 10;
      switch (Number(this.dataset.speed)) {
        case 1:
          this.speed = 3
          break;
        case 2:
          this.speed = 2
          break;
        case 3:
          this.speed = 1
          break;
      }
      this.enablePause = this.dataset.pause == 'true' ? true : false;
    }

    animationLoop() {
      if(this.enablePause && this.stopped) return window.requestAnimationFrame(() => { this.animationLoop(); });

      const firstListItem = this.querySelector('span:first-child');
      let rightSideOfFirstItem = firstListItem.getBoundingClientRect().right;

      if(rightSideOfFirstItem <= this.containerLeft - this.offsetMargin) {
        this.currentLeft = -1;
        this.appendChild(firstListItem);
      }

      this.style.marginLeft = `${this.currentLeft}px`;
      this.currentLeft -= this.speed;

      window.requestAnimationFrame(() => { this.animationLoop(); });
    }

    connectedCallback() {
      this.addEventListener('mouseenter', () => this.stopped = true);
      this.addEventListener('mouseleave', () => this.stopped = false);

      this.animationLoop();
    }
  }

  customElements.define('marquee-text', MarqueeText);
}
